export const SET_PROVIDERS = 'SET_PROVIDERS';
export const setProvidersAction = (providers) => ({
  type: SET_PROVIDERS,
  payload: providers,
});
